/*
 * Copyright © 2023 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

/* eslint-disable max-len */
export const toolTipContent = {
  roundTripTime: `Round-trip time (RTT) is the time a packet of data takes to go from sender to receiver and back again. High RTT can cause the video to lag, freeze, or slow down. This is usually attributed to slow or overloaded networks.`,
  jitter: `Jitter is the fluctuation of latency over time. Due to network congestion, data can take longer to travel. High jitter typically results in short bursts of video freezing, slow video, and choppy audio.`,
  packetLoss: `Packet loss is caused when data fails to reach its destination. High packet loss results in video freezing, slow video, and choppy audio. Packet loss is usually caused by overloaded routers or high CPU load on the machine.`,
  bitrate: `Bitrate is the way we measure the speed of the upload and download transfers. If a sender uploads data too quickly and exceeds the transfer speed, the network gets overwhelmed and can cause issues for everyone. Symptoms of this can be frozen video, downscaled video, frame-rate drops, choppy audio, and potentially dropped connections.`,
}
